/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { CommuneDto } from "../dto/GenApi.iNotPaie.Dto/CommuneDto";
import { ParametreDto } from "../dto/GenApi.iNotPaie.Dto/ParametreDto";

export default class securiteSocialHelper {
    /* ****************************************************** SET NUMERO ****************************************************** */
    static setSecuSocialMandatory(
        numeroSecuriteSociale: string,
        codeCivilite: string | undefined,
        dateNaissance: string | null,
        getCommuneNaissance: CommuneDto | undefined,
        getPaysNaissance: ParametreDto | null): string {
        let numeroSecuriteSocialeAuto = numeroSecuriteSociale.replace(/ /gi, "");

        // Civility (1 char)
        let civilityCode = "";
        if (codeCivilite === "M.") {
            civilityCode = "1";
        } else if (codeCivilite === "MLE" || codeCivilite === "MME") {
            civilityCode = "2";
        }
        if (numeroSecuriteSocialeAuto != undefined && civilityCode != "") {
            numeroSecuriteSocialeAuto = civilityCode + numeroSecuriteSocialeAuto.substr(0 + civilityCode.length);
        }

        // Year of birth (2 & 3 characters)
        if (dateNaissance != undefined && dateNaissance != "") {
            const yearOfBirth = dateNaissance.toString().split("-")[0].substr(-2);
            if (numeroSecuriteSocialeAuto.length > 1) { // MAJ
                numeroSecuriteSocialeAuto = numeroSecuriteSocialeAuto.substr(0, 1) + yearOfBirth + numeroSecuriteSocialeAuto.substr(1 + yearOfBirth.length);
            } else { // 1ère fois
                numeroSecuriteSocialeAuto += yearOfBirth;
            }
        }

        // birth month (4 & 5 characters)
        if (dateNaissance != undefined && dateNaissance != "") {
            const monthOfBirth = dateNaissance.toString().split("-")[1].substr(-2);
            if (numeroSecuriteSocialeAuto.length > 3) { // MAJ
                numeroSecuriteSocialeAuto = numeroSecuriteSocialeAuto.substr(0, 3) + monthOfBirth + numeroSecuriteSocialeAuto.substr(3 + monthOfBirth.length);
            } else { // 1ère fois
                numeroSecuriteSocialeAuto += monthOfBirth;
            }
        }

        // birth department (6 & 7 characters) && Insee number (8 & 10 characters)
        if (numeroSecuriteSocialeAuto != undefined) {
            if (getPaysNaissance) {
                let codeInsee = "";

                if (getPaysNaissance.LibelleCourt) {
                    codeInsee = this.ajusterString(getPaysNaissance.LibelleCourt as string);
                } else if (getCommuneNaissance != null && getCommuneNaissance.CodeInsee) {
                    codeInsee = this.ajusterString(getCommuneNaissance.CodeInsee);
                }

                numeroSecuriteSocialeAuto = numeroSecuriteSocialeAuto.substr(0, 5) + codeInsee + numeroSecuriteSocialeAuto.substr(5 + codeInsee.length);
            }
        }

        return numeroSecuriteSocialeAuto;
    }

    /* ****************************************************** FORMAT ****************************************************** */

    static ajusterString(str: string): string {
        if (str.length === 4) {
            return "0" + str;
        }

        return str;
    }

    static formatNumeroSecuriteSocial(val: string): string {
        let numeroSecuriteSociale = "";

        for (let i = 0; i < val.length; i++) {
            numeroSecuriteSociale += val[i];
            if ((i == 0 || i == 2 || i == 4 || i == 6 || i == 9 || i == 12) && i < val.length - 1) {
                numeroSecuriteSociale += " ";
            }
        }

        if (numeroSecuriteSociale.length > 21) {
            numeroSecuriteSociale = numeroSecuriteSociale.substr(0, 21);
        }

        return numeroSecuriteSociale;
    }

    /* ****************************************************** CHECK VALIDITE ****************************************************** */

    static checkCleValidation(numeroSecuriteSociale: string): boolean {

        const numeroSecuClean = numeroSecuriteSociale.toUpperCase().replace(/ /gi, "").replace(/\t/gi, "").replace(/2A/gi, "19").replace(/2B/gi, "18");

        if (numeroSecuClean.length != 15) {
            return false;
        }

        const cle = Number(numeroSecuClean.substring(13));
        const numero = Number(numeroSecuClean.substring(0, 13));
        const calcule = 97 - (numero % 97);

        if (calcule != cle) {
            console.warn("La bonne clé est : " + calcule);

            return false;
        }

        return true;
    }

    /**
     * Vérifie si le numéro de sécurité sociale est valide
     * @param numeroSecuriteSociale
     * @returns
     */
    static isValidSecuSocial(numeroSecuriteSociale: string | null | undefined): string[] {
        const listError: string[] = [];

        if (numeroSecuriteSociale == null) {
            listError.push("Le numéro de sécurité sociale n'est pas renseigné");
        } else {

            const numeroSecu = numeroSecuriteSociale.replace(/ /gi, "").replace(/\t/gi, "");

            if (numeroSecu.length != 15) {
                listError.push("Le numéro de sécurité social doit faire 15 caractères (13+2)");
            } else if (!this.checkCleValidation(numeroSecu)) {
                listError.push("Le numéro de sécurité social ne répond pas aux critères de validation par la clé");
            }
        }

        return listError;
    }

}



// WEBPACK FOOTER //
// ./src/Helper/securiteSocialHelper.ts